var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _path3, _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataDashboards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 346,
    viewBox: "0 0 371 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5986,
    y: 23.3997,
    width: 340.179,
    height: 322.18,
    fill: "#14D3A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1973,
    y: 97.064,
    width: 340.802,
    height: 148.831,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 167.39,
    height: 165.59,
    fill: "#3600CE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 181.789,
    width: 167.39,
    height: 165.59,
    fill: "#3600CE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3965,
    y: 77.3953,
    width: 14.3991,
    height: 50.3969,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3955,
    y: 64.7952,
    width: 14.3991,
    height: 62.9961,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104.394,
    y: 50.3955,
    width: 14.3991,
    height: 77.3952,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.783 34.199C282.462 34.199 292.902 37.3658 301.782 43.2991C310.661 49.2323 317.582 57.6654 321.669 67.532C325.756 77.3986 326.825 88.2556 324.742 98.7299C322.658 109.204 317.516 118.825 309.964 126.377C302.413 133.929 292.791 139.071 282.317 141.155C271.843 143.238 260.986 142.169 251.119 138.082C241.253 133.995 232.819 127.074 226.886 118.195C220.953 109.315 217.786 98.8752 217.786 88.1956H271.783V34.199Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.786 79.1952C208.786 72.1043 210.183 65.0828 212.896 58.5316C215.61 51.9804 219.587 46.0279 224.601 41.0138C229.615 35.9997 235.568 32.0224 242.119 29.3088C248.67 26.5952 255.692 25.1985 262.783 25.1985L262.783 79.1952L208.786 79.1952Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 183.589,
    width: 354.578,
    height: 143.991,
    fill: "#3600CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7969 282.582L116.094 242.084L177.29 282.582L240.286 242.084L304.182 229.485",
    stroke: "white",
    strokeWidth: 1.79989
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.6962,
    cy: 281.681,
    r: 8.0995,
    fill: "#14D3A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.293,
    cy: 242.085,
    r: 8.0995,
    fill: "#14D3A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.29,
    cy: 281.681,
    r: 8.0995,
    fill: "#14D3A6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.285,
    cy: 242.085,
    r: 8.0995,
    fill: "#14D3A6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.082,
    cy: 229.485,
    r: 8.0995,
    fill: "#14D3A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDashboards);
export default __webpack_public_path__ + "static/media/DataDashboards.5f2018c1cd7a76a8140387aec8682a61.svg";
export { ForwardRef as ReactComponent };